// Brand-aligned color palette using different shades of black and grey with better contrast
export const CHART_COLORS = {
  octonary: "#e5e7eb", // gray-200 - very light grey
  primary: "#111827", // gray-900 - very dark charcoal
  quaternary: "#9ca3af", // gray-400 - light grey
  quinary: "#d1d5db", // gray-300 - lighter grey
  secondary: "#374151", // gray-700 - medium dark grey
  senary: "#1f2937", // gray-800 - dark charcoal (for variation)
  septenary: "#4b5563", // gray-600 - medium grey (for variation)
  tertiary: "#6b7280", // gray-500 - neutral grey
};

// Array version for charts that need multiple colors - ordered for maximum contrast
export const CHART_COLOR_PALETTE = [
  "#111827", // Very dark charcoal
  "#6b7280", // Medium grey
  "#1f2937", // Dark charcoal
  "#9ca3af", // Light grey
  "#374151", // Medium dark grey
  "#d1d5db", // Very light grey
  "#4b5563", // Medium grey variant
  "#e5e7eb", // Nearly white grey
];

// Single color for charts that only need one
export const PRIMARY_CHART_COLOR = CHART_COLORS.primary;

// Gradient versions for enhanced visual appeal
export const CHART_GRADIENTS = {
  primary: ["#1f2937", "#374151"],
  secondary: ["#374151", "#4b5563"],
  tertiary: ["#4b5563", "#6b7280"],
};
